import { render, staticRenderFns } from "./VoxyTable.vue?vue&type=template&id=7d9110e8&"
import script from "./VoxyTable.vue?vue&type=script&lang=js&"
export * from "./VoxyTable.vue?vue&type=script&lang=js&"
import style0 from "./VoxyTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports